import Avatar from "@material-ui/core/Avatar"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import ListItemText from "@material-ui/core/ListItemText"
import { useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle"
import StoreMallDirectoryRoundedIcon from "@material-ui/icons/StoreMallDirectoryRounded"
import { useContext, useEffect, useState } from "react"
import useEndereco from "../../contexts/EnderecoContext"
import SiteContext from "../../contexts/SiteContext"
import { useTextos } from "../../contexts/TextosContext"

export default function DialogEnderecos({ DialogConfirmacaoinformacoes = () => {} }) {
    const {
        usuarioLogado,

        aplicativoDados,

        estabelecimentoAtual,

        carrinho,
    } = useContext(SiteContext)
    const textos = useTextos()

    const [enderecos, setEnderecos] = useState(
        usuarioLogado?.cliente?.enderecos ? usuarioLogado.cliente.enderecos : []
    )

    const {
        selecionarEndereco,
        selecionarRetiradaNoLocal,

        abrirEnderecos,

        cadastrarNovoEndereco,
        fecharListaEnderecos,
    } = useEndereco()

    useEffect(() => {
        setEnderecos(usuarioLogado?.cliente?.enderecos ?? [])

        if (abrirEnderecos && !estabelecimentoAtual?.manterEnderecoCliente) {
            cadastrarNovoEndereco()
            fecharListaEnderecos()
        }
    }, [abrirEnderecos])

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const permiteRetiradaBalcao =
        aplicativoDados?.permiteRetiradaBalcao || estabelecimentoAtual?.permiteRetiradaBalcao

    const handleClickEndereco = endereco => {
        selecionarEndereco(endereco)

        fecharListaEnderecos()
        if (carrinho.pedido?.itens?.length) {
            DialogConfirmacaoinformacoes(true)
        }
    }

    const handleRetirada = () => {
        selecionarRetiradaNoLocal()

        if (carrinho.pedido?.itens?.length) {
            DialogConfirmacaoinformacoes(true)
        }
    }

    return (
        <Dialog
            open={abrirEnderecos}
            aria-labelledby="lista-enderecos-title"
            fullWidth={true}
            maxWidth={"md"}
            onClose={fecharListaEnderecos}
        >
            {!fullScreen ? <img src={aplicativoDados.urlLogo} className="imgModal" /> : null}

            <DialogTitle id="lista-enderecos-title">
                <IconButton className="setaVoltarModal" onClick={fecharListaEnderecos}>
                    <ArrowForwardIosIcon />
                </IconButton>
                {textos.enderecos}
            </DialogTitle>

            <DialogContent className="lista-enderecos">
                <Button
                    fullWidth
                    className="botao-adicionar-endereco"
                    onClick={cadastrarNovoEndereco}
                >
                    {textos.adicionarEndereco}
                </Button>
                <Divider />
                {permiteRetiradaBalcao ? (
                    <ListItem
                        button
                        divider
                        onClick={handleRetirada}
                        className="item-lista-enderecos"
                    >
                        <ListItemAvatar className="avatar-endereco-container">
                            <Avatar className="simbolo-endereco">
                                <StoreMallDirectoryRoundedIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={textos.retirarNoLocal}
                            secondary={textos.detalheRetirada}
                        />
                    </ListItem>
                ) : null}
                {enderecos.map((endereco, index) => {
                    if (!endereco.ativo) return
                    return (
                        <ListItem
                            key={index}
                            button
                            divider
                            onClick={() => handleClickEndereco(endereco)}
                            className="item-lista-enderecos"
                        >
                            <ListItemAvatar className="avatar-endereco-container">
                                <Avatar className="simbolo-endereco">
                                    <PersonPinCircleIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={`${endereco.logradouro}, Nº ${endereco.numero}${
                                    endereco.complemento ? ` - ${endereco.complemento}` : ""
                                }`}
                                secondary={`${endereco.bairro}, ${endereco.cidade} / ${endereco.uf}`}
                            />
                        </ListItem>
                    )
                })}
            </DialogContent>
        </Dialog>
    )
}
